import VerifyEmail from 'containers/UserProfile/VerifyEmail';
import VerifyPhone from 'containers/UserProfile/VerifyPhone';
import React, { Redirect, useHistory, useLocation } from 'react-router-dom';

import { getAccessToken, isVerificationAccount } from '@app/redux/auth/auth.selectors';
import { useAppSelector } from '@app/redux/hooks';
import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import MFA_METHODS_ENUM from '../MFASetupPage/enums/MFA_METHODS.enum';

function AccountVerificationPage() {
	const accessToken = useAppSelector(getAccessToken);
	const { isVerificationPhoneRequired, isVerificationEmailRequired, isPhoneVerified, isEmailVerified, needMFASetup } =
		useAppSelector(isVerificationAccount);
	const { state, search } = useLocation<{ selectedMFA?: MFA_METHODS_ENUM } | undefined>();
	const { selectedMFA } = state || {};
	const needPhoneVerify =
		(isVerificationPhoneRequired && !isPhoneVerified) || (selectedMFA === MFA_METHODS_ENUM.SMS && !isPhoneVerified);
	const needEmailVerify =
		(isVerificationEmailRequired && !isEmailVerified) || (selectedMFA === MFA_METHODS_ENUM.EMAIL && !isEmailVerified);
	const generateRoutePath = useGenerateRoutePath();
	const history = useHistory();

	const declineMFAMethod = () => {
		history.push(generateRoutePath(RoutePaths.VERIFICATION.MFA_SETUP));
	};

	if (!accessToken) return null;
	if (needEmailVerify) return <VerifyEmail onDecline={selectedMFA && declineMFAMethod} />;
	else if (needPhoneVerify) return <VerifyPhone onDecline={selectedMFA && declineMFAMethod} />;
	else if (needMFASetup)
		return (
			<Redirect
				to={{
					pathname: generateRoutePath(RoutePaths.VERIFICATION.MFA_SETUP, { withRequiredQueryParams: false }),
					state: { selectedMFA },
					search,
				}}
			/>
		);
	else return <Redirect to={generateRoutePath(RoutePaths.MAIN.APPLICATIONS)} />;
}

export default AccountVerificationPage;
